import type { GanttIndicatorsDialogProps } from "./types-gantt-indicators-dialog";
import { useGanttIndicatorsDialogViewModel } from "./use-gantt-indicators-dialog";
import { GanttIndicatorsDialogView } from "./view-gantt-indicators-dialog";

/**
 * "Exibir indicadores no Gantt" sobre o `Dialog`: rascunho local, Salvar efetiva e Cancelar descarta; ao menos
 * um indicador fica sempre ativo (no último, o aviso troca a dica e o toggle trava). Une os dois dialogs de Carga de Trabalho.
 */
export function GanttIndicatorsDialog(props: GanttIndicatorsDialogProps) {
  const viewModel = useGanttIndicatorsDialogViewModel(props);

  return <GanttIndicatorsDialogView {...viewModel} />;
}
GanttIndicatorsDialog.displayName = "GanttIndicatorsDialog";
